import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    dialogStyle: { width: 550, height: 350, padding: 10 },

    tableCell: {
      fontSize: '0.8125rem !important',
      padding: 0,
      width: '300px',
      height: '45px',
    },
    valueTitle: {
      marginBottom: '5px',
      display: 'flex',
    },
    dialogTitle: {
      borderBottom: 'solid 1px #d5d2d5',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '12px',
      paddingRight: '5px',
      height: '60px',
      backgroundColor: '#f6f6f7',
      alignItems: 'center',
      width: '350px',
    },
    dialogHeader: {
      paddingLeft: 20,
      paddingRight: 13,
      ...theme.dialogs.header,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 60,
      minHeight: 60,
    },
    headerTitle: {
      ...theme.dialogs.title,
    },
    dialogContent: {
      flex: '1 1 auto',
      padding: 20,
      overflowY: 'auto',
      paddingBottom: 0,
    },
    dialogActions: {
      padding: 20,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    lessHeight: {
      height: '270px',
    },
    inputRoot: {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
      height: '3rem',
      fontSize: '14px',
      lineHeight: 'normal',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1rem',
      borderRadius: '3px',
    },
    selectInput: {
      height: '3rem',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '3px',
      padding: '0 14px',
      boxSizing: 'border-box',
      fontWeight: 300, 
    },
    oldValueBox: {
      border: '1px solid #aaa2aa',
      height: '3rem',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1rem',
      borderRadius: '3px',
      paddingLeft: '0.8rem',
      userSelect: 'none',
      fontSize: '14px',
      '& span': {
        marginLeft: '5px',
      },
    },
    iconBtnStyle: {
      width: 30,
      height: 30,
      borderRadius: 6,
      padding: 0,
    },
    resetParamsButton: {
      width: 'fit-content',
      minWidth: '130px',
    },
    enumerationsFormWrapper: {
      width: '100%',
    },
  })
);

export default useStyles;
